import type { SearchPosition } from '@iheartjane/types';
import { SEARCH_POSITION } from '@iheartjane/types';
import { hex } from 'wcag-contrast';

import type { SidebarSection } from './EditorSidebar';

export const getHighlightedSections = (
  activeSection: SidebarSection | null,
  searchPosition: SearchPosition = 'split'
): string[] => {
  if (!activeSection) return [];

  if (['category_tabs', 'product_cards'].includes(activeSection)) {
    return [activeSection];
  }

  if (activeSection === 'logo') return ['header'];

  if (activeSection === 'search') {
    if (
      searchPosition === SEARCH_POSITION.header ||
      searchPosition === SEARCH_POSITION.filters
    )
      return [searchPosition];

    if (searchPosition === SEARCH_POSITION.split) return ['header', 'filters'];

    if (searchPosition === SEARCH_POSITION.content_header)
      return ['full_width_search'];
  }

  return [];
};

const GRAYS_ULTRALIGHT = '#F7F7F7';
const GRAYS_WHITE = '#FFFFFF';
export const getIconColor = (backgroundColor?: string) => {
  const isDarkBackground =
    hex(backgroundColor || GRAYS_WHITE, GRAYS_ULTRALIGHT) >= 3;
  return isDarkBackground ? 'grays-white' : 'grays-black';
};
